import { Injectable } from '@angular/core';
import { HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderUtilService } from '@app/lib/b2b-services/loader/loader-util.service';
import { BYPASS_LOADER } from '@app/lib/b2b-services/util/http-client.service';

@Injectable({
  providedIn: 'root',
})
export class HttpLoaderInterceptorService {
  constructor(private loaderService: LoaderUtilService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    if (req.context.get(BYPASS_LOADER) === true) {
      return next.handle(req);
    } else {
      this.loaderService.show();

      return next.handle(req).pipe(
        finalize(async () => {
          this.loaderService.hide();
        })
      );
    }
  }

  /*  startLoader(loaderConfig: LoadingOptions): Observable<any> {
      if (this.count === 0) {
        this.count++;
        LoggerService.log('count before starting the loader -> ', this.count);
        // start the loader
        return from(this.loadingController.create(loaderConfig)).pipe(
          switchMap((loading: HTMLIonLoadingElement) => {
            LoggerService.log('Inside loadingController loader is ', loading);
            return from(loading.present());
          })
        );
      } else {
        // no need to start the loader -> loader is already there
        LoggerService.log('count before ignoring the loader -> ', this.count);
        this.count++;
        return of({});
      }
    }*/
}
